<ng-scrollbar externalViewport appearance="compact" visibility="hover">
  <div scrollViewport [ngStyle]="{ height: 'calc(100vh - 66px)' }">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      @for (nav of menuList(); track $index) {
        @if (nav.subMenuList && nav.subMenuList.length > 0) {
          <li
            nz-submenu
            [nzTitle]="titleTemplate"
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? nav.name : ''"
            [nzDisabled]="!!nav.disabled"
          >
            <ng-template #titleTemplate>
              <a class="flex gap-3 items-center min-w-[40px] min-h-[40px]">
                <svg-icon [src]="nav.icon"></svg-icon>
                <span>{{ nav.name }}</span>
              </a>
            </ng-template>

            <ul>
              @for (item of nav.subMenuList; track $index) {
                @if (item.subMenuList && item.subMenuList.length > 0) {
                  <!-- 🔹 SECOND LEVEL SUBMENU -->
                  <li
                    nz-submenu
                    [nzTitle]="subTitleTemplate"
                    [nzDisabled]="!!item.disabled"
                  >
                    <ng-template #subTitleTemplate>
                      <a
                        class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
                      >
                        <svg-icon [src]="item.icon"></svg-icon>
                        <span>{{ item.name }}</span>
                      </a>
                    </ng-template>

                    <ul>
                      @for (subItem of item.subMenuList; track $index) {
                        <!-- 🔹 THIRD LEVEL MENU ITEMS -->
                        <li
                          nz-menu-item
                          [nzMatchRouterExact]="subItem.exact"
                          nzMatchRouter
                          [nzDisabled]="!!subItem.disabled"
                        >
                          <a
                            [routerLink]="subItem.link"
                            class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
                          >
                            <svg-icon [src]="subItem.icon"></svg-icon>
                            <span>{{ subItem.name }}</span>
                          </a>
                        </li>
                      }
                    </ul>
                  </li>
                } @else {
                  <!-- 🔹 SECOND LEVEL ITEM -->
                  <li
                    nz-menu-item
                    [nzMatchRouterExact]="item.exact"
                    nzMatchRouter
                    [nzDisabled]="!!item.disabled"
                  >
                    <a
                      [routerLink]="item.link"
                      class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
                    >
                      <svg-icon [src]="item.icon"></svg-icon>
                      <span>{{ item.name }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
          </li>
        } @else {
          <!-- 🔹 FIRST LEVEL ITEM -->
          <li
            nz-menu-item
            [nzDanger]="nav.type === 'Danger'"
            [nzMatchRouterExact]="nav.exact"
            nzMatchRouter
            nz-tooltip
            nzTooltipPlacement="right"
            [nzTooltipTitle]="isCollapsed ? nav.name : ''"
            [nzDisabled]="!!nav.disabled"
          >
            <a
              [routerLink]="nav.link"
              class="flex gap-3 items-center min-w-[40px] min-h-[40px]"
            >
              <svg-icon [src]="nav.icon"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </li>
        }
      }
    </ul>
  </div>
</ng-scrollbar>
